/**
 * Footer link set for the conveyancer portal — shared between the app-level
 * footer (body-scrolling pages) and the copy pinned inside the dashboard's
 * fixed viewport frame.
 */
export const FOOTER_LINKS = [
  { label: "Code of Conduct", href: "/code-of-conduct" },
  { label: "Terms of Service", href: "/terms" },
  { label: "POPIA & Privacy Policy", href: "/popia-notice" },
];
